export {MessagesFullSearch as default};

/**
* Messages Full Search params
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesFullSearch {

	/**
   * Search Type
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  qs = 'fullsearch';

  /**
   * Folder Id
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  qsearchmbox;

  /**
   * Email From Field
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	from;

  /**
   * Email To Field
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	to;

  /**
   * Email Subject Field
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	subject;

  /**
   * Email Body Contains
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	body_contain;

  /**
   * Email Body Exclude
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	body_exclude;

  /**
   * Has Flag Read
   *
   * @public
   *
   * @type {Boolean|undefined}
   *
   * @since 7.0.0
   */
	flag_read;

  /**
   * Has Flag Flagged
   *
   * @public
   *
   * @type {Boolean|undefined}
   *
   * @since 7.0.0
   */
	flag_flagged;

   /**
   * Filter by Attachments
   *
   * @public
   *
   * @type {Number|undefined}
   *
   * @since 7.0.0
   */
	filter_attachments;

   /**
   * Filter by Size type
   *
   * @public
   *
   * @type {Number|undefined}
   *
   * @since 7.0.0
   */
	filter_size_type;

   /**
   * Filter by Size value
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
	filter_size_value;

   /**
   * Filter date start
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	filter_date_start;

   /**
   * Filter date start
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
	filter_date_end;

  /**
   * Sets all QuickSearch Params from a query string object
   *
   * @public
   *
   * @param {Object} query_string
   *
   * @since 7.0.0
   */
  setFromQueryString(query_string) {
    if (!query_string || query_string.qs !== 'fullsearch') {
      return;
    }

    for (let k in query_string) {
      if (query_string[k] === 'true') {
          this[k] = true;
          continue;
      }

      if (query_string[k] === 'false') {
          this[k] = false;
          continue;
      }

      if (!isNaN(query_string[k])) {
        this[k] = parseInt(query_string[k]);
        continue;
      }

      this[k] = query_string[k];
    }
  }
}